import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('SectionHeading')(({ theme, disableBorder }) => css({
    display: 'flex',
    flexDirection: 'row',
    minHeight: 45,
    width: '100%',
    gap: '8px',
    padding: '4px 0',
    justifyContent: 'space-between',
    borderBottom: !disableBorder && `3px solid ${theme.colors.grey[3]}`,
}));
themeStyles.addBaseStyles('SectionGroupHeading')(({ theme, padding = '', rightPadding }) => {
    const paddings = {
        m: ['4px 0 4px 16px', '4px 0 4px 16px', '4px 0 4px 48px'],
        l: ['4px 0 4px 32px', '4px 0 4px 32px', '4px 0 4px 96px'],
    };
    return css({
        display: 'flex',
        position: 'relative',
        flexDirection: 'row',
        minHeight: 54,
        width: '100%',
        gap: '8px',
        padding: paddings[padding],
        paddingRight: `${rightPadding} !important`,
        justifyContent: 'space-between',
        borderBottom: `1px solid ${theme.colors.grey[3]}`,
    });
});
themeStyles.addBaseStyles('SubSectionGroupItem')(({ theme }) => css({
    display: 'flex',
    flexDirection: 'row',
    minHeight: 34,
    gap: 4,
    margin: ['0 16px 0 32px', '0 16px 0 32px', '0 44px 0 96px'],
    padding: ['4px 28px 4px 16px', '4px 28px 4px 16px', '4px 0 4px 48px'],
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.colors.grey[3]}`,
}));
themeStyles.addBaseStyles('ModelWrapper')(css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    pb: 'm',
}));
themeStyles.addBaseStyles('Title')(css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 'auto 0',
}));
themeStyles.addBaseStyles('SectionGroupTitle')(({ isValue }) => css({
    display: 'flex',
    gap: '4px',
    width: 'max',
    padding: '4px 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 'auto 0',
    whiteSpace: isValue && 'nowrap',
}));
themeStyles.addBaseStyles('FloatingSectionGroupTitle')(css({
    display: 'flex',
    gap: '4px',
    width: 'max',
    padding: '4px 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 0 auto 0',
    position: ['absolute', 'absolute', 'static'],
    top: 1,
    right: 45,
}));
themeStyles.addBaseStyles('SubSectionGroupTitle')(css({
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 'auto 0',
    fontSize: '16px !important',
}));
themeStyles.addBaseStyles('SubSectionGroupItemTitle')(css({
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 'auto 0',
    fontSize: ['14px !important', '14px !important', '16px !important'],
    lineHeight: ['22px !important', '22px !important', '26px !important'],
}));
themeStyles.addBaseStyles('PrintLink')(() => css({
    whiteSpace: 'nowrap',
    display: 'flex',
}));
themeStyles.addBaseStyles('StyledBox')(() => css({
    display: 'inline-flex',
}));
themeStyles.addBaseStyles('StyledTooltip')(() => css({
    alignSelf: 'flex-start',
    display: 'inline-flex',
    verticalAlign: 'super',
    ml: '8px',
}));
export default themeStyles;
